import api from '@/utils/api';

export default {
    data: () => ({manualRemoval: null, manualRemovalError: '', manualRemovalNotice: ''}),
    computed: {
        manualRemovalIdentity() {
            const user = this.$store.getters.currentUser || {};
            return JSON.stringify([user.company, user.userId, this.currentTimesheetId()]);
        }
    },
    watch: {manualRemovalIdentity() { this.resetManualRemoval(); }},
    beforeDestroy() { this.resetManualRemoval(); },
    methods: {
        resetManualRemoval() {
            this.manualRemoval = null;
            this.manualRemovalError = '';
            this.manualRemovalNotice = '';
            this.removingLineId = null;
        },
        isCurrentManualRemoval(operation) {
            return this.manualRemoval === operation && operation.identity === this.manualRemovalIdentity;
        },
        removeManualLine(line) {
            if (this.manualRemoval || !this.canRemoveManualLine(line)) return;
            // Deleting a row must not require saving or resolving the rest of the sheet.
            this.manualRemoval = {identity: this.manualRemovalIdentity, timesheetId: this.currentTimesheetId(),
                lineId: Number(line.id), name: this.lineEmployeeName(line), removed: false};
            this.manualRemovalError = '';
            this.manualRemovalNotice = '';
        },
        closeManualRemoval(event) {
            if (this.removingLineId !== null) {
                if (event && event.preventDefault) event.preventDefault();
                return;
            }
            this.resetManualRemoval();
        },
        async confirmManualRemoval() {
            const operation = this.manualRemoval;
            if (!operation || operation.removed || this.removingLineId !== null) return;
            this.manualRemovalError = '';
            if (this.periodNavigationLocked) {
                this.manualRemovalError = 'Дождитесь завершения текущего действия в табеле и повторите удаление.';
                return;
            }
            this.removingLineId = operation.lineId;
            let release = () => {};
            try {
                if (this._editQueue) release = await this._editQueue.pause();
                if (!this.isCurrentManualRemoval(operation)) return;
                const line = (this.sheet.lines || []).find(row => Number(row.id) === operation.lineId);
                if (!this.canRemoveManualLine(line)) {
                    this.manualRemovalError = 'Строка изменилась или больше недоступна для удаления. Закройте окно и проверьте отметки и права доступа.';
                    return;
                }
                await api.delete(`/api/timesheets/${operation.timesheetId}/lines/${operation.lineId}`, {ignoreModal: true});
                if (!this.isCurrentManualRemoval(operation)) return;
                operation.removed = true;
                this.discardRemovedLineDrafts(operation.lineId);
                release();
                await this.refreshManualRemoval(operation);
            } catch (error) {
                if (!this.isCurrentManualRemoval(operation)) return;
                if (operation.removed) this.manualRemovalNotice = 'Сотрудник удалён. Не удалось обновить экран — нажмите «Обновить табель».';
                else this.manualRemovalError = this.responseMessage(error, 'Не удалось удалить сотрудника из табеля. Повторите попытку.');
            } finally {
                release();
                if (this.isCurrentManualRemoval(operation)) this.removingLineId = null;
            }
        },
        async retryManualRemovalRefresh() {
            const operation = this.manualRemoval;
            if (!operation || !operation.removed || this.removingLineId !== null || !this.isCurrentManualRemoval(operation)) return;
            this.removingLineId = operation.lineId;
            try { await this.refreshManualRemoval(operation); }
            finally { if (this.isCurrentManualRemoval(operation)) this.removingLineId = null; }
        },
        async refreshManualRemoval(operation) {
            this.manualRemovalNotice = '';
            try {
                const refreshed = await this.loadTimesheet(operation.timesheetId, {
                    syncRoute: false, ignoreModal: true, throwActivityErrors: true,
                    isCurrent: () => this.isCurrentManualRemoval(operation)
                });
                if (!this.isCurrentManualRemoval(operation)) return;
                if (refreshed === false) {
                    // The row is already removed locally; normal queue refresh reconciles aggregates.
                    this.editSyncPending = true;
                    this.scheduleEditRefresh();
                }
                this.successMessage = `${operation.name} удалён из табеля.`;
                this.resetManualRemoval();
            } catch (error) {
                if (!this.isCurrentManualRemoval(operation)) return;
                const status = error && error.response && error.response.status;
                if (status === 401 || status === 403) {
                    this.resetManualRemoval();
                    this.clearCurrentTimesheet();
                    this.errorMessage = `${operation.name} удалён из табеля. Просмотр табеля сейчас недоступен: проверьте вход и права доступа.`;
                    return;
                }
                this.manualRemovalNotice = 'Сотрудник удалён, но не удалось обновить табель. Нажмите «Обновить табель». Повторное удаление не требуется.';
            }
        }
    }
};
